import Vue from 'vue';

Vue.component('vue-popover', require('./components/Popover.vue').default);
Vue.component('vue-form', require('./components/Form.vue').default);
Vue.component('vue-radio', require('./components/Radio.vue').default);
Vue.component('vue-checkbox', require('./components/Checkbox.vue').default);
Vue.component('vue-input', require('./components/Input.vue').default);
Vue.component('vue-input-number', require('./components/InputNumber.vue').default);
Vue.component('vue-textarea', require('./components/Textarea.vue').default);
Vue.component('vue-button', require('./components/Button.vue').default);
Vue.component('vue-tag', require('./components/Tag.vue').default);
Vue.component('vue-alert', require('./components/Alert.vue').default);
Vue.component('vue-multiselect', require('./components/Multiselect.vue').default);
Vue.component('vue-modals', require('./components/Modals.vue').default);
Vue.component('vue-time-picker', require('./components/TimePicker.vue').default);
Vue.component('vue-date-picker', require('./components/DatePicker.vue').default);

Vue.component('layout-nav', require('./components/layouts/Nav.vue').default);
Vue.component('layout-header', require('./components/layouts/Header.vue').default);

Vue.component('page-style-guide', require('./pages/PageStyleGuide.vue').default);
Vue.component('page-dashboard', require('./pages/PageDashboard.vue').default);
Vue.component('page-users', require('./pages/PageUsers.vue').default);
Vue.component('page-customers', require('./pages/PageCustomers.vue').default);
Vue.component('page-families', require('./pages/PageFamilies.vue').default);
Vue.component('page-products', require('./pages/PageProducts.vue').default);
Vue.component('page-orders', require('./pages/PageOrders.vue').default);
Vue.component('page-shops', require('./pages/PageShops.vue').default);
Vue.component('page-recurrences', require('./pages/PageRecurrences.vue').default);
Vue.component('page-carts', require('./pages/PageCarts.vue').default);
Vue.component('page-notifications', require('./pages/PageNotifications.vue').default);
Vue.component('page-lock', require('./pages/PageLock.vue').default);
Vue.component('page-login', require('./pages/PageLogin.vue').default);
